export default __webpack_public_path__ + "static/tools-cc2b1526d345400bdd83251be4ffdcba.png";